import { ConfigurationType } from '@server/parser';
import { DataTableId } from '../../../common/table/utils';
import { ConfigurationItem } from '../../../parser/ParserTypes';
import {
  DataTableBaseColumn,
  DataTableRow,
  DataTableOnSortChangeClbk,
} from '../../../common/table/TableTypes';
import { SubPageTypes } from '../../types';
import { DropdownProps } from '@sweep-io/sweep-design/dist/components/Tabs/tabsTypes';
import { SortOrder } from '../../../common/types';

export interface BaseLayoutProps {
  onCloseDialog?: () => void;
  isExpandedMode: boolean;
  hideAddObjectButton?: boolean;
  crmOrgId: string;
  columns: DataTableBaseColumn[];
  rows: DataTableRow[];
  pageType: SubPageTypes;
  topBarProps: LayoutTopBarProps;
  tableProps?: LayoutTableProps;
  tabsProps?: LayoutTabsProps;
  hideHeader?: boolean;
  dataTestId?: string;
}

export interface LayoutTopBarProps {
  searchPlaceholder?: string;
  sortOptions?: { label: string; value: string }[];
  sortProps?: { sortBy: string; sortOrder: SortOrder };
  downloadCsvJsx?: React.ReactNode;
  filtersJsx?: React.ReactNode;
  label: string;
  pageHeader?: string;
  hideFiltersAndSort?: boolean;
  showResultsCount?: boolean;
}

export interface LayoutTableProps {
  tableId: DataTableId;
  onRowClick: (
    event: React.MouseEvent<HTMLTableCellElement, MouseEvent>,
    row: DataTableRow,
  ) => void;
  onSortChange: DataTableOnSortChangeClbk;
  allowColumnsManipulation?: boolean;
  tableType?: LayoutTableType;
}

export interface LayoutDependenciesPanelProps {
  configurationItem: ConfigurationItem;
  type: ConfigurationType;
}

export interface LayoutTabsProps {
  tabs: { label: string; value: string }[];
  dropdown?: DropdownProps;
  activeTab: string;
  onTabChange: (event: React.SyntheticEvent, newValue: string) => void;
}

export enum LayoutTableType {
  table = 'table',
  virtualizedTable = 'virtualizedTable',
  virtualizedTableWithCustomColumns = 'virtualizedTableWithCustomColumns',
  customColumnsTable = 'customColumnsTable',
}
